import { __assign } from "tslib";
import React from "react";
import { Content } from './components/Content';
import { toast } from "react-toastify";
import { ErrorIcon } from "./assets/error";
import { InfoIcon } from "./assets/info";
import { SuccessIcon } from "./assets/success";
import { WarningIcon } from "./assets/warning";
import { Spinner } from "../Spinner";
import s from './notification.module.css';
var notifyInfo = function (message, description, options) {
    toast.info(React.createElement(Content, { message: message, description: description }), __assign({ icon: InfoIcon, className: "".concat(s.border_info, " ").concat(s.toast) }, options));
};
var notifySuccess = function (message, description, options) {
    toast.success(React.createElement(Content, { message: message, description: description }), __assign({ icon: SuccessIcon, className: "".concat(s.border_success, " ").concat(s.toast) }, options));
};
var notifyWarning = function (message, description, options) {
    toast.warn(React.createElement(Content, { message: message, description: description }), __assign({ icon: WarningIcon, className: "".concat(s.border_warning, " ").concat(s.toast) }, options));
};
var notifyError = function (message, description, options) {
    toast.error(React.createElement(Content, { message: message, description: description }), __assign({ icon: ErrorIcon, className: "".concat(s.border_error, " ").concat(s.toast) }, options));
};
var notifyLoading = function (message, description, options) {
    toast(React.createElement(Content, { message: message, description: description }), __assign({ icon: Spinner, className: "".concat(s.border, " ").concat(s.toast) }, options));
};
export var Notify = __assign(__assign({}, toast), { info: notifyInfo, success: notifySuccess, warn: notifyWarning, error: notifyError, loading: notifyLoading });
//# sourceMappingURL=Notify.js.map